export default "__VITE_PUBLIC_ASSET__6b3f222a__"